module.exports = __webpack_public_path__ + "img/horizontal_6_5_5010.fef5095c.png";